import React from 'react';

import { useReturnAuthorizationSummaryWidgetQuery } from 'generated/graphql';



export interface IData {
  orderNumber: string;
  returnNumber: string;
  storeTypeDisplayName: string;
}

export function useQuery(returnAuthorizationId: string, asCustomer: boolean) {
  const tuple = useReturnAuthorizationSummaryWidgetQuery({
    variables: {
      returnAuthorizationId,
      asCustomer
    }
  });

  return React.useMemo(
    () => {
      const returnAuth = tuple.data?.returnAuthorization;
      const returnAuthLite = tuple.data?.returnAuthorizationLite;

      const data: IData = {
        orderNumber: returnAuth?.order?.orderNumber ?? returnAuthLite?.order.orderNumber ?? '',
        returnNumber: returnAuth?.returnNumber ?? returnAuthLite?.returnNumber ?? '',
        storeTypeDisplayName: returnAuth?.store.type.displayName ?? returnAuthLite?.order.storeName ?? ''
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
